module.exports = __webpack_public_path__ + "static/media/correct.e9f9eb2f.mp3";